module.exports = __webpack_public_path__ + "static/media/29ADMSPC19.46679a33.jpg";